import React from "react";
import { useTranslation } from "react-i18next";
import Seo from "../components/Seo";
import Dimension from "../components/Dimension";
import PageHead from "../components/PageHead";
import { LT_BRAND } from "../data";

function Legal() {
  const { t } = useTranslation();

  return (
    <div className="container">
      <Seo page="legal" path="/legal" />

      <PageHead
        title={`${t("legal.heroTitle1")} ${t("legal.heroTitle2")}`}
        lede={t("legal.heroDesc")}
      />

      {/* ---- Impressum ---- */}
      <div className="band">
        <Dimension label={t("legal.impressum.eyebrow")} />
      </div>
      <h2 className="h-section">{t("legal.impressum.title")}</h2>
      <dl className="deflist deflist-legal">
        <dt>{t("legal.impressum.operator")}</dt>
        <dd>
          LTplus AG
          <br />
          <span className="muted">{t("legal.impressum.legalForm")}</span>
        </dd>

        <dt>{t("legal.impressum.seat")}</dt>
        <dd>
          Loorenstrasse 62
          <br />
          8053 Zürich, Switzerland
        </dd>

        <dt>{t("legal.impressum.office")}</dt>
        <dd>
          {LT_BRAND.street}
          <br />
          {LT_BRAND.city}, Switzerland
        </dd>

        <dt>{t("legal.impressum.represented")}</dt>
        <dd>
          Louis Trümpler
          <br />
          <span className="muted">{t("legal.impressum.boardRole")}</span>
        </dd>

        <dt>UID</dt>
        <dd>
          <a
            href={`https://www.zefix.ch/de/search/entity/list/firm/${LT_BRAND.ehraId}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            {LT_BRAND.uid}
          </a>
        </dd>

        <dt>CH-ID</dt>
        <dd>{LT_BRAND.chId}</dd>

        <dt>EHRA-ID</dt>
        <dd>{LT_BRAND.ehraId}</dd>

        <dt>{t("legal.impressum.register")}</dt>
        <dd>{t("legal.impressum.registerVal")}</dd>

        <dt>{t("legal.impressum.contact")}</dt>
        <dd>
          <a href={`mailto:${LT_BRAND.email}`}>{LT_BRAND.email}</a>
          <br />
          <a href={`mailto:${LT_BRAND.contactEmail}`}>
            {LT_BRAND.contactEmail}
          </a>
        </dd>

        <dt>{t("legal.impressum.vat")}</dt>
        <dd>{t("legal.impressum.vatVal")}</dd>
      </dl>
      <p className="label legal-note">{t("legal.impressum.note")}</p>

      {/* ---- Data protection ---- */}
      <div className="band">
        <Dimension label={t("legal.privacy.eyebrow")} />
      </div>
      <h2 className="h-section">{t("legal.privacy.title")}</h2>
      <div className="legal-body">
        <p>{t("legal.privacy.intro")}</p>

        <h3>{t("legal.privacy.controllerTitle")}</h3>
        <p>
          {t("legal.privacy.controllerBody")}{" "}
          <a href={`mailto:${LT_BRAND.email}`}>{LT_BRAND.email}</a>.
        </p>

        <h3>{t("legal.privacy.dataTitle")}</h3>
        <p>{t("legal.privacy.dataIntro")}</p>

        <div className="diagram">
          <pre>
            {`browser ──▶ lt.plus              Vercel CDN, static assets
        │
        ├──▶ fonts.gstatic.com     Archivo web font files
        │
        └──▶ vercel-insights.com   page-view counts, cookieless, first-party`}
          </pre>
        </div>

        <ul>
          <li>
            <strong>{t("legal.privacy.item1Name")}</strong> —{" "}
            {t("legal.privacy.item1Body")}
          </li>
          <li>
            <strong>{t("legal.privacy.item2Name")}</strong> —{" "}
            {t("legal.privacy.item2Body")}
          </li>
          <li>
            <strong>{t("legal.privacy.item4Name")}</strong> —{" "}
            {t("legal.privacy.item4Body")}
          </li>
        </ul>

        <h3>{t("legal.privacy.cookiesTitle")}</h3>
        <p>{t("legal.privacy.cookiesBody")}</p>

        <h3>{t("legal.privacy.rightsTitle")}</h3>
        <p>{t("legal.privacy.rightsBody")}</p>

        <h3>{t("legal.privacy.retentionTitle")}</h3>
        <p>{t("legal.privacy.retentionBody")}</p>

        <h3>{t("legal.privacy.transferTitle")}</h3>
        <p>{t("legal.privacy.transferBody")}</p>
      </div>

      {/* ---- Liability ---- */}
      <div className="band">
        <Dimension label={t("legal.liability.eyebrow")} />
      </div>
      <h2 className="h-section">{t("legal.liability.title")}</h2>
      <div className="legal-body">
        <p>{t("legal.liability.body")}</p>

        <h3>{t("legal.copyright.title")}</h3>
        <p>{t("legal.copyright.body")}</p>

        <h3>{t("legal.jurisdiction.title")}</h3>
        <p>{t("legal.jurisdiction.body")}</p>

        <h3>{t("legal.version.eyebrow")}</h3>
        <p className="band-bottom">{t("legal.version.body")}</p>
      </div>
    </div>
  );
}

export default Legal;
